import React, { useEffect, useState } from 'react';
import { Modal, Box, ButtonGroup, Button, MenuItem, Paper, Stack, TextField, Typography } from '@mui/material';
import { toast } from 'react-toastify';
import EditIcon from '@mui/icons-material/Edit';
import Styles from '../../../common/styles/styles';

export default function NotificationModal({  notification, onTriggerCreate, onTriggerUpdate }) {
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState('');
  
  const [formData, setFormData] = useState({
      id: '',
      name: '',
      description: '',
      enabled: false
  });

  const handleOpen = () => {
    setOpen(true);
    setTitle('Create Notification');    
    setFormData({ ...formData, id: '', name: '', description: '', enabled: '' });
  }

  const handleEditOpen = () => {
    setOpen(true);
    setTitle('Update Notification');
  }

  const handleUpdate = async (event) => {
      const result = await createNotification(event);      
      
      if (result === 'Success') {
        setOpen(false);
        if ( title === 'Create Notification' ) {
          onTriggerCreate(formData);
        } else {
          onTriggerUpdate(formData);
        }      
      }
  }

  const handleClose = async () => {
    setOpen(false);
    if (formData.id === '') {    
      await setFormData({ ...formData, id: '', name: '', description: '', enabled: '' });
    }
  }
  
  const handleInputChange = (field) => (e) => {      

      let value = e.target.value;
      setFormData({ ...formData, [field]: value });
      
  };
  
  const options = [
    { value: true, label: 'True' },
    { value: false, label: 'False' }
  ];

  const createNotification = async (event) => {
    event.preventDefault();
    let result = null;

    try {
        
        if (formData.id === '') {
          const response = await fetch(`${process.env.REACT_APP_API}/notifications/create`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(formData),
          });

            result = await response.json();
            if (result.message === 'Success') {
              await handleClose();
            } else {
              toast.error(result.message);
            }
        } else {
            const response = await fetch(`${process.env.REACT_APP_API}/notifications/update`, {
                method: 'PUT',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            result = await response.json();
            if (result.message === 'Success') {
              await handleClose();
            } else {
              toast.error(result.message);
            }
          }
          return result.message;
    } catch (error) {
      toast.error('Network error.  Please try again: ', error);
      return false;
    }
  }
  
  const textFieldStyles = Styles.textFieldStyles;

  useEffect(() => {
    if (notification.id !== undefined) {
      setFormData(notification);
    } 
  }, [notification]);

  return (
    <>
        { formData.id === "" && 
          <Button variant="contained" color="primary" sx={{ mt: 2 }} onClick={handleOpen}>
            Add New
          </Button>
        }
        
        { formData.id !== '' && 
          <Button variant="outlined" color="success" size="small" onClick={handleEditOpen}>
              <EditIcon />
          </Button>
        }
        
        <Modal 
          open={open} 
          onClose={handleClose}
          style={{
            overlay: {
              backgroundColor: '#080030', // Semi-transparent black
            },
            content: {
              backgroundColor: '#080030',
            },
          }}
        >
            <Box sx={{color: 'white', p: 4}}>
                <Box
                  component={Paper}
                  elevation={3}
                  sx={{
                    mx: 'auto',
                    width: 400,
                    bgcolor: '#1e1e1e',
                    p: 2,
                  }}
                >
                  <Typography variant="h4" component="h2" color="white" mb={2}>
                    {title}
                  </Typography>

                  <Box component="form" onSubmit={handleUpdate}>
                    <Stack spacing={2}>
                      <TextField
                        required
                        fullWidth
                        label="Name"
                        value={formData.name}
                        onChange={handleInputChange('name')}
                        sx={ textFieldStyles }
                      />
                      <TextField
                        required
                        fullWidth
                        label="Description"
                        value={formData.description}
                        onChange={handleInputChange('description')}
                        sx={ textFieldStyles }
                      />
                      <TextField
                        select
                        required
                        fullWidth
                        label="Enabled"
                        value={formData.enabled}
                        onChange={handleInputChange('enabled')}
                        sx={ textFieldStyles }
                        >
                        {options.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                    </TextField>    
                    
                  
                  <ButtonGroup 
                    size="small"
                    variant="contained" 
                    aria-label="Basic button group" 
                    fullWidth
                    sx={{ mt:2 }}
                  >
                    <Button
                      onClick={handleClose}
                      type="cancel"
                      variant="contained"
                      sx={ Styles.buttonStyle }
                    >
                      Cancel
                    </Button>              
                    <Button
                      type="submit"                      
                      variant="contained"
                      sx={{ ...Styles.buttonStyle,  ml:4 }}
                    >
                      {title}
                    </Button>
                  </ButtonGroup>
                </Stack>
              </Box>
            </Box>
          </Box>          
        </Modal>
    </>
  );
}